 
import React, {useContext, useEffect, useState} from 'react';
import {BridleContext} from '../BridleContextProvider';
import {
    findMatchingProductIds,
    findProductWithAttributeIds,
    getAttributeIdsFromState,
    getAttributesGroupedInDisplayOrder,
    getInitialStateFromAttributeValues,
    getProductsByAttributeIds,
    getStateByAttributes,
    getUniqueAttributeCombinations,
    getUpdatedAttributes
} from '../HelperFunctions';
import Attributes from './Attributes';
import BridleImage from './BridleImage';
import Message from './Message';
import Price from './Price';
import Subtotal from './Subtotal';

const Page = ({pageName, attributes, pieces, productId, sizeGuide}) => {
    const {options, setOptions} = useContext(BridleContext);
    const [selectedState, setSelectedState] = useState({
        ...getInitialStateFromAttributeValues(pieces.attributeValues),
        ColorId: !productId || productId > -1 ? options.Color.ColorId : '',
        ColorName: !productId || productId > -1 ? options.Color.ColorName : ''
    });
    const [pricing, setPricing] = useState({});
    const [compatibleAttributes, setCompatibleAttributes] = useState(attributes);
    const NO_PRODUCT_ID = -1;

    useEffect(() => {
        if (productId && productId > -1) {
            const match = findMatchingProductIds(pieces.products, productId);
            if (match[0].productAttributes.length === 2) {
                setSelectedState({
                    SizeId: match[0].productAttributes[0].attributeValueId,
                    ColorId: options.Color.ColorId
                });
            } else {
                setSelectedState({
                    ...selectedState,
                    SizeId: match[0].productAttributes[0].attributeValueId,
                    StyleId: match[0].productAttributes[2].attributeValueId,
                    ColorId: options.Color.ColorId
                });
            }

            setPricing(match[0].price);
        }
    }, []);

    function handleSelection({attributeName, attributeValueId, attributeValueName}) {
        const currentState = {
            ...selectedState
        };

        if (attributeValueId !== undefined) {
            currentState[`${attributeName}Id`] = attributeValueId;
            currentState[`${attributeName}Name`] = attributeValueName;
        }

        const foundProduct = findProductWithAttributeIds(pieces.products, getAttributeIdsFromState(currentState));
        const attributeCombinationsFromSelection = getUniqueAttributeCombinations(
            getProductsByAttributeIds(pieces.products, [attributeValueId])
        );

        setCompatibleAttributes(
            getAttributesGroupedInDisplayOrder(
                getUpdatedAttributes(pieces.attributeValues, attributeCombinationsFromSelection, attributeName)
            )
        );
        setSelectedState(
            getStateByAttributes(pieces, currentState, attributeCombinationsFromSelection, attributeValueId)
        );

        setOptions({
            ...options,
            [pageName]: {
                productId:
                    foundProduct && attributeValueId ? foundProduct.productId : !attributeValueId ? NO_PRODUCT_ID : '',
                price: foundProduct && attributeValueId ? foundProduct.price : '',
                image: foundProduct && attributeValueId ? foundProduct.image : pieces.unselectedImage
            }
        });

        foundProduct && attributeValueId ? setPricing(foundProduct.price) : setPricing({});
    }

    return (
        <>
            <BridleImage />
            <Attributes
                name={pageName}
                attributes={compatibleAttributes}
                state={selectedState}
                productId={productId}
                handleSelection={handleSelection}
                sizeGuide={sizeGuide}
            />
            <Message productId={productId} />
            <Price pricing={pricing} />
            <Subtotal />
        </>
    );
};

export default Page;
